<template>
  <div class="leads-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.audiology'), disabled: true },
        { title: this.$t('leads.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable
          :querySearch.sync="querySearch"
        />
        <va-popover
          v-if="isFromEvollu || isFromEntity(8001)"
          placement="left"
          class="ml-2"
          :message="$t('leads.uploadamleads')">
          <span class="icon i-file-upload" @click.prevent="onClickUploadSPICEFiles"></span>
        </va-popover>
        <va-popover
          placement="left"
          :message="$t('leads.download')">
          <span class="icon i-cloud-download" @click.prevent="exportLeadsExcel"></span>
        </va-popover>
        <va-popover
          placement="left"
          :message="$t('tags.tooltip')">
          <span class="icon i-tag" @click.prevent="onClickManageTags"></span>
        </va-popover>
        <va-popover
          placement="left"
          :message="$t('leads.change_aud_provider')">
          <span class="icon fa fa-headphones" @click.prevent="onClickUpdateAudProvider"></span>
        </va-popover>
      </div>

    </Breadcrumbs>

    <LeadsTable
      ref="tableView"
      v-if="hasLoadedEntities"
      :entities="entities"
      :querySearch="querySearch"
      @lead-selected="leadSelected"
      @loaded="onTableLoaded"
      @filters-updated="onTableFiltersUpdated" />

    <LeadDetail
      v-if="showLeadDetails"
      :service="component.service"
      :selectedLead="selectedLead"
      :entities="entities"
      :entitiesWrite="entitiesWrite"
      :salePriceEntitiesRead="salePriceEntitiesRead"
      :salePriceEntitiesWrite="salePriceEntitiesWrite"
      @cancel="leadDetailsClosed"
      @updatedSession="leadSessionUpdated"
      @updatedLeadEntity="leadEntityUpdated"
      @eventCreated="eventCreated"/>

    <TagsList
      v-if="showTagsModal"
      @tagWasCreated="tagCreated"
      @tagWasUpdated="tagUpdated"
      @tagWasDeleted="tagDeleted"
      @closeTagList="closeTagList" />

    <AudProviderModal
      v-if="tableViewState !== null && showAudProviderModal"
      :hasLeadsSelected="hasLeadsSelected"
      :selectedLeads="getSelectedLeadsCount()"
      :nrOfFilters="activeTableFiltersCount"
      :pages="tableViewState.totalPages"
      :currentDisplayedLeads="getTableViewData()"
      @audProviderWasUpdated="updatedAudProvider"
      @closeAudProviderModal="closeAudProviderComponent" />

    <UploadLeadsStatusAM v-if="isUploadingExcels"
      :service="component.service"
      @amexcelUpload="onUploadLeadsStatusAMSuccessful"
      @modalWasClosed="onUploadLeadsStatusAMModalWasClosed">
    </UploadLeadsStatusAM>

  </div>
</template>
<script>
import LeadsTable from './LeadsTable'
import { LeadsService } from '@/api/LeadsService'
import LeadDetail from './LeadDetail'
import TagsList from './TagsList'
import AudProviderModal from './AudProviderModal'
import UploadLeadsStatusAM from './UploadLeadsStatusAM'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IsFromEvollu from '@/mixins/IsFromEvolluMixin'
import Searchable from '@/components/common/Searchable'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { TABLE_LEADS } from '@/local-storage/LocalStorageKeys'
import entities from '@/components/entities/index.vue';

const MAX_RESULTS_IN_EXCEL = 10000

export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: {
    Searchable,
    LeadDetail,
    TagsList,
    LeadsTable,
    AudProviderModal,
    UploadLeadsStatusAM,
    Breadcrumbs
  },
  mixins: [
    IsFromEvollu,
    IndexTablesMixin
    // -> This mixin cannot be used since we need to wait for filterable entities to load
    // Fix this dumb way of loading entities for the filters (follow the normal procedure as in the rest of the platform)
    // and this solution can be used once more...
  ],
  data () {
    return {
      showLeadDetails: false,
      showTagsModal: false,
      showAudProviderModal: false,
      isUploadingExcels: false,
      selectedLead: null,
      entities: [],
      entitiesWrite: [],
      salePriceEntitiesRead: [],
      salePriceEntitiesWrite: [],
      hasLoadedEntities: false,
      tableViewState: null,
      activeTableFiltersCount: 0,
      querySearch: '',
      localStorageKey: TABLE_LEADS,
      isExportingLeadsExcel: false,
      isExportingLeadsExcelToast: null,
      hasLeadsSelected: false
    }
  },
  created () {
    this.loadEntities()
  },
  methods: {
    getSelectedLeadsCount: function () {
      const selectedLeads = this.$refs.tableView.getSelectedLeads()
      if(selectedLeads.length > 0) {
        //console.log(this.tableViewState)
        //Since we have selected leads, we will only use the selected data, thus, limiting the pages to 1 (current)
        this.hasLeadsSelected = true
        return selectedLeads.length

      }
      return this.tableViewState.count
    },
    onClickUpdateAudProvider: function () {
      if (this.tableViewState !== null) {
        this.showAudProviderModal = true
      }
    },
    onClickManageTags: function () {
      if (this.tableViewState !== null) {
        this.showTagsModal = true
      }
    },
    onClickUploadSPICEFiles: function () {
      if (this.tableViewState !== null) {
        this.isUploadingExcels = !this.isUploadingExcels
      }
    },
    updatedAudProvider: function () {
      this.$refs.tableView.reload()
      this.hasLeadsSelected = false
    },
    closeAudProviderComponent: function () {
      this.showAudProviderModal = false
    },
    onTableFiltersUpdated: function ({ count }) {
      this.activeTableFiltersCount = count
    },
    onTableLoaded: function (state) {
      this.tableViewState = state
    },
    getTableViewData: function () {
      const selectedLeads = this.$refs.tableView.getSelectedLeads()
      if(selectedLeads.length > 0) {
        return selectedLeads
      }
      return this.$refs.tableView.getData()
    },
    closeTagList: function () {
      this.showTagsModal = false
    },
    tagCreated: function (tag) {
      this.$refs.tableView.tags.push(tag)
    },
    tagUpdated: function (tag) {
      let childComponent = this.$refs.tableView
      let data = childComponent.leadsTable.data
      data.forEach(row => {
        row.tags.forEach(item => {
          if (item.id === tag.id) {
            item.name = tag.name
            item.color = tag.color
          }
        })
      })
      childComponent.tags.forEach(item => {
        if (item.id === tag.id) {
          item.name = tag.name
          item.color = tag.color
        }
      })
      childComponent.filters.tags.forEach(item => {
        if (item.id === tag.id) {
          item.name = tag.name
          item.color = tag.color
        }
      })
    },
    tagDeleted: function (tag) {
      let childComponent = this.$refs.tableView
      let data = childComponent.$refs.leadsTable.data
      // Update view from tags that were removed
      data.forEach(row => {
        row.tags = row.tags.filter(rowTag => rowTag.id !== tag.id)
      })
      // Update tag options
      childComponent.filters.tags = childComponent.filters.tags.filter(_tag => _tag.id !== tag.id)
      childComponent.tags = childComponent.tags.filter(_tag => _tag.id !== tag.id)
    },
    eventCreated: function () {
      this.refreshTable()
      this.showLeadDetails = false
    },
    refreshTable: function () {
      this.$refs.tableView.reload()
    },
    leadSessionUpdated: function ({ lead }) {
      this.refreshTable()
      this.selectedLead = lead
    },
    leadEntityUpdated: function ({ lead }) {
      this.refreshTable()
      this.selectedLead = lead
    },
    loadEntities: function () {
      /*LeadsService.getEntities()
        // eslint-disable-next-line camelcase
        .then(({ leads_read, leads_write, leads_sale_price_read, leads_sale_price_write }) => {
          this.entities = leads_read // eslint-disable-line camelcase
          this.entitiesWrite = leads_write // eslint-disable-line camelcase
          this.salePriceEntitiesRead = leads_sale_price_read // eslint-disable-line camelcase
          this.salePriceEntitiesWrite = leads_sale_price_write // eslint-disable-line camelcase
          this.hasLoadedEntities = true
        }).catch(err => console.log(err))*/
      if(this.leadsService) {
        const entitiesV2 = this.leadsService.entities
        //console.log("Original entities count: "+this.entities.length)
        //console.log("New entities count: "+entitiesV2.length)


        //info type 2000 - Leads Info Type 2001 - Aud Providers
        const leadsWritePermission = this.leadsService ? this.leadsService.user_permissions.filter(perm => perm.access_type >= 2 && (perm.info_type === 2000 || perm.info_type === 2001)) : []
        const entitiesWriteV2 = entitiesV2.filter(entity => leadsWritePermission.some(perm => perm.entity_id === null || perm.entity_id === entity.id )).map(elem => elem.id) || []
        //console.log("Original entities Write count: "+this.entitiesWrite.length)
        //console.log("New entities Write count: "+entitiesWriteV2.length)

        const leadsSalePriceReadPermission = this.leadsService ? this.leadsService.user_permissions.filter(perm => perm.access_type >= 1 && (perm.info_type === 2100 || perm.info_type === 2101)) : []
        const salePriceEntitiesReadVv2 = entitiesV2.filter(entity => leadsSalePriceReadPermission.some(perm => perm.entity_id === null || perm.entity_id === entity.id )).map(elem => elem.id) || []
        //console.log("Original entities Sale Price Read count: "+this.salePriceEntitiesRead.length)
        //console.log("New entities Sale Price Read count: "+salePriceEntitiesReadVv2.length)

        const leadsSalePriceWritePermission = this.leadsService ? this.leadsService.user_permissions.filter(perm => perm.access_type >= 2 && (perm.info_type === 2100 || perm.info_type === 2101)) : []
        const salePriceEntitiesWriteVv2 = entitiesV2.filter(entity => leadsSalePriceWritePermission.some(perm => perm.entity_id === null || perm.entity_id === entity.id )).map(elem => elem.id) || []
        //console.log("Original entities Sale Price Write count: "+this.salePriceEntitiesWrite.length)
        //console.log("New entities Sale Price Write count: "+salePriceEntitiesWriteVv2.length)

        this.entities = entitiesV2
        this.entitiesWrite = entitiesWriteV2
        this.salePriceEntitiesRead = salePriceEntitiesReadVv2
        this.salePriceEntitiesWrite = salePriceEntitiesWriteVv2
        this.hasLoadedEntities = true
      }

    },
    leadSelected: function ({ lead }) {
      this.selectedLead = lead
      this.showLeadDetails = true
    },
    exportLeadsExcel: function () {
      if (!(this.isExportingLeadsExcel || this.tableViewState === null)) {
        if (this.tableViewState.count <= MAX_RESULTS_IN_EXCEL) {
          if (!this.isExportingLeadsExcel) {
            this.isExportingLeadsExcel = true
            this.isExportingLeadsExcelToast = this.showToast(this.$t('leads.generating_lead_excel'), {
              ...this.$store.state.successToastOptions,
              icon: 'cloud-download',
              duration: null
            })
            const selectedLeads = this.$refs.tableView.getSelectedLeads()
            let params
            if(selectedLeads.length > 0) {
              params = {
                leads: selectedLeads.map(lead => lead.id).join(',')
              }
            } else {
              const customQueries = this.$refs.tableView.getCustomQueries()
              params = {
                entity: customQueries.entity,
                audprovider: customQueries.audprovider,
                status: customQueries.status,
                datestart: customQueries.datestart,
                dateend: customQueries.dateend,
                date: customQueries.date,
                tags: customQueries.tags
              }
            }
            LeadsService.exportExcel(params)
              .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'leads.xlsx')
                document.body.appendChild(link)
                link.click()
                this.isExportingLeadsExcelToast.goAway(100)
              }).catch(error => {
                console.log(error)
                this.isExportingLeadsExcelToast.goAway(100)
                setTimeout(() => {
                  this.showToast(this.$t('leads.download_excel_generic_failure'), this.$store.state.errorToastOptions)
                }, 500)
              })
              .finally(() => {
                this.isExportingLeadsExcel = false
                this.isExportingLeadsExcelToast = null
              })
          }
        } else {
          this.showToast(this.$t('leads.download_excel_failure_too_many_results', { count: MAX_RESULTS_IN_EXCEL }), this.$store.state.errorToastOptions)
        }
      }
    },
    leadDetailsClosed: function () {
      this.showLeadDetails = false
      this.selectedLead = null
    },
    onUploadLeadsStatusAMModalWasClosed: function () {
      this.isUploadingExcels = false
    },
    onUploadLeadsStatusAMSuccessful: function () {
      this.$refs.tableView.reload()
    },
    isFromEntity: function (entityId) {
      return this.$auth.user().entity.id === entityId
    }
  },
  beforeDestroy: function () {
    if (this.isExportingLeadsExcelToast !== null && this.isExportingLeadsExcelToast !== undefined) {
      this.isExportingLeadsExcelToast.goAway()
    }
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(service => service.slug === 'audiology') || null
    }
  }
}
</script>

<style lang="scss">

.leads-index {

  .separator-lead-details {
    // box-shadow: 0px 3px 8px 2px #e8e8e8;
    // margin-bottom: 3rem;
    margin-bottom: 30px;
    margin-top: -30px;
    border: none;
    height: 50px;
    box-shadow: 0 20px 20px -20px #dad8d8;
  }

  .is-uppercase{
    text-transform: uppercase
  }

  .no-break {
    white-space: nowrap;
  }

  .highlight {
    background-color: #cccccc !important;
  }

  .is-warning {
    color: #f7cc36 !important;
  }

  .scroll {
    padding: 0;
    .vuestic-scrollbar {
      min-height: 90%;
      height: 90%;
      position: fixed;
      .scrollbar-content {
        margin-top: 0px;
      }
      .scrollbar-wrapper {
        box-shadow: 0px 4px 70px -18px #a0a0a0;;
      }
    }
  }

  #leadsTable th.name {
    min-width: 150px;
  }

  #leadsTable th.city {
    min-width: 100px;
  }

  #leadsTable th.status {
    min-width: 150px;
  }

   #leadsTable th.appointment_request {
    min-width: 70px;
  }

  #leadsTable th.has_HearingLoss {
    min-width: 70px;
  }

  #leadsTable th.hearingLossResult {
    min-width: 50px;
  }

  #leadsTable th.questionnaire_score {
    min-width: 95px;
  }

  #leadsTable th.diagnosed_hl {
    min-width: 85px;
  }

  #leadsTable th.hearing_aid {
    min-width: 75px;
  }

  #leadsTable th.qualified_at {
    min-width: 75px;
  }

  #leadsTable th.has_HearingLoss,
  #leadsTable th.hearingLossResult,
  #leadsTable th.questionnaire_score,
  #leadsTable th.diagnosed_hl,
  #leadsTable th.hearing_aid,
  #leadsTable th.qualified_at {
    text-align: center;
  }

  #leadsTable td.has_HearingLoss,
  #leadsTable td.hearingLossResult,
  #leadsTable td.questionnaire_score,
  #leadsTable td.diagnosed_hl,
  #leadsTable td.hearing_aid,
  #leadsTable td.qualified_at {
    text-align: center;
  }

  .close-modal-button {
    button {
      margin: -5px;
      background-color: white !important;
      background-image: none !important;
      padding-bottom: 0.5rem;
      padding-top: 0.5rem;
    }
    i.va-button__content__icon {
      width: 1rem;
      color: $evollu-gray-light;
    }
  }

  $assetsPath: "../../assets";
  @import '@/sass/icons/icons-classes.scss';

  #leadsTable {
    tr:hover {
      .i-evollu-hl-normal {
        @extend .i-evollu-hl-normal-white;
      }
      .i-evollu-hl-mild {
        @extend .i-evollu-hl-mild-white;
      }
      .i-evollu-hl-severe {
        @extend .i-evollu-hl-severe-white;
      }
      .i-evollu-questionnaire {
        @extend .i-evollu-questionnaire-white;
      }
      .i-evollu-questionnaire-danger {
        @extend .i-evollu-questionnaire-danger-white;
      }
      .i-evollu-hearing-aid {
        @extend .i-evollu-hearing-aid-white;
      }
    }
  }

  .i-cloud-download {
    margin-left: 0.5rem;
  }
}

</style>
